import React from 'react';
import { ToggleButton } from 'react-native-paper';
import styled from 'styled-components/native';

import { CollectionPreviewStatus as Status } from '@src/enums';

type StatusPickerProps = {
  status: Status;
  onChangeStatus: (status: Status) => void;
};

const RowButton = styled(ToggleButton.Row)`
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
`;

export const StatusPicker: React.FC<StatusPickerProps> = (props) => {
  const { status, onChangeStatus } = props;

  const statusChangeHandler = (_status: string) => {
    switch (_status) {
      case '1':
        onChangeStatus(Status.DRAFT);
        break;
      case '2':
        onChangeStatus(Status.PUBLISHED);
        break;
      default:
        break;
    }
  };

  return (
    <RowButton onValueChange={statusChangeHandler} value={status.toString()}>
      <ToggleButton icon="calendar-check" value={Status.PUBLISHED.toString()} />
      <ToggleButton icon="calendar-times" value={Status.DRAFT.toString()} />
    </RowButton>
  );
};
